import { JobSeekingStatus } from 'types/types';
import { User } from 'types/user';

export const shouldDisplayRefreshActiveJobSeekingStatusBanner = (
  user: User,
  isConnectPreferencesPage: boolean
): boolean => {
  const daysLeftOfActiveJobSeekingStatus = getDaysLeftBeforeActiveJobSeekingStatusExpires(user);

  if (
    isConnectPreferencesPage ||
    user?.preference?.job_seeking_status !== JobSeekingStatus.OPEN_TO_WORK_AND_MATCHES ||
    daysLeftOfActiveJobSeekingStatus === null
  ) {
    return false;
  } else if (daysLeftOfActiveJobSeekingStatus <= 3 && daysLeftOfActiveJobSeekingStatus > 0) {
    return true;
  } else {
    return false;
  }
};

export const getDaysLeftBeforeActiveJobSeekingStatusExpires = (user: User): number | null => {
  const jobSeekingStatus = user?.preference?.job_seeking_status;
  const statusUpdatedAt = user?.preference?.job_seeking_status_updated_at;

  if (!jobSeekingStatus || !statusUpdatedAt) {
    return null;
  }

  const MILLISECONDS_IN_A_DAY = 1000 * 60 * 60 * 24;

  const updatedAt = new Date(statusUpdatedAt);
  const expirationDate = new Date(updatedAt.getTime() + 28 * MILLISECONDS_IN_A_DAY);

  // Truncate both to midnight UTC to calculate the difference infull calendar days
  const today = new Date();
  const utcToday = new Date(
    Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate())
  );
  const utcExpiration = new Date(
    Date.UTC(
      expirationDate.getUTCFullYear(),
      expirationDate.getUTCMonth(),
      expirationDate.getUTCDate()
    )
  );

  // Calculate days between today and expiration date
  const diffTime = utcExpiration.getTime() - utcToday.getTime();

  // If status expires today, round up the partial day to 1 day
  if (diffTime === 0) {
    return 1;
  }

  // If status has already expired, return null
  if (diffTime < 0) {
    return null;
  }

  // If status expires after today, return the number of days left
  const daysLeft = Math.floor(diffTime / MILLISECONDS_IN_A_DAY);
  return daysLeft;
};
